import React from 'react';
import HeadingButtonBase from './HeadingButtonBase';

function HeadingTwoButton() {
  return <HeadingButtonBase format="heading_two" title="H2" />;
}

export default HeadingTwoButton;
